/* eslint-disable */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { Form, Input, Select, DatePicker, Radio } from 'formik-antd';
import { Modal, message, Spin, Col, Upload, Button as ButtonAntd, Space, Input as InputAntd, Tooltip } from 'antd';
import { FaUpload, FaMinus, FaPlus } from 'react-icons/fa';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import locale from 'antd/es/date-picker/locale/pt_BR';
import 'moment/locale/pt-br';
import { Table } from '~/components/Table';
import Pagination from '~/components/Pagination';
import errorHandler from '~/Utils/errorHandler';
import Row from '~/components/Row';
import Thumb from '~/components/Thumb';
import Can from '~/components/Can';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import Button from '~/components/Button';
import { decrypt, dynamicCost, getBase64, getSuccessMessageByModule } from '~/Utils/index';
import InputCurrency from '~/components/Form/InputCurrency';
import api from '~/services/api';

const { Search } = InputAntd;

const initialValues = {
  description: '',
  type: 'input',
  value: '',
  paid_out: '',
  person: null,
};

export default function MovementForm({ visible, onClose, movementID }) {
  const { t } = useTranslation();
  const [recordData, setRecordData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [loadingPeople, setLoadingPeople] = useState(false);
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [bankAccountOptions, setbankAccountOptions] = useState([]);
  const [providersOptions, setProvidersOptions] = useState([]);
  const [costsOptions, setCostsOptions] = useState([]);
  const [peopleOptions, setPeopleOptions] = useState([]);
  const [file, setFile] = useState(null);
  const [deleteOldFile, setDeleteOldFile] = useState(false);
  const { permissions } =
    JSON.parse(decrypt(localStorage.getItem('@App:user'))) !== null &&
    JSON.parse(decrypt(localStorage.getItem('@App:user')));

  const [search, setSearch] = useState('');
  const [meta, setMeta] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowName, setSelectedRowName] = useState('');

  const handleSave = async (values, { setErrors }) => {
    setLoading(true);

    values.person = null;

    if (!selectedRowKeys[0]) {
      console.log('sem pessoa');
      values.person_id = null;
    } else {
      values.person_id = selectedRowKeys[0];
      console.log('selectedRowKeys[0]', selectedRowKeys[0]);
    }

    delete values.isEdit;
    try {
      if (values.id) {
        if (deleteOldFile === true) {
          await api.delete(`/files/${values.id}/attachment`);
          values.attachment_id = null;
        }
        await api.put(`/movements/${values.id}`, values);
        message.success(getSuccessMessageByModule(t('screens:movements.titleSingular'), t('messages:successUpdated')));
        if (file && file.originFileObj) {
          const files = new FormData();
          files.append('file', file.originFileObj);
          await api.post(`/files/${values.id}/attachment`, files);
        }
      } else {
        const { data } = await api.post('/movements', values);
        message.success(getSuccessMessageByModule(t('screens:movements.titleSingular'), t('messages:successCreated')));
        if (file && file.originFileObj) {
          const files = new FormData();
          files.append('file', file.originFileObj);
          await api.post(`/files/${data.id}/attachment`, files);
        }
      }
      setFile(null);
      setDeleteOldFile(null);
      onClose();
    } catch (error) {
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const fetchRecords = async () => {
    try {
      const response = await api.get(`/movements/${movementID}`);
      const data = JSON.parse(response.data);

      if (data?.cost_center?.costs) {
        setCostsOptions(data.cost_center.costs);
      }

      setFile(data.attachment);
      if (document.getElementById('uploadButton')) {
        document.getElementById('uploadButton').style.cursor = data.attachment !== null ? 'no-drop' : 'pointer';
      }
      // console.log('data', data);
      setRecordData(data);
      if (data.person_id) {
        setSelectedRowKeys([data.person_id]);
        setSelectedRowName(data.person.name);
        setSearch('');
        // console.log('data.person', data.person_id, data.person.name);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const fetchCostCenters = async () => {
    try {
      const { data } = await api.get('/costCenters');
      setCostCenterOptions(data);
    } catch (error) {
      errorHandler(error);
    }
  };

  // const fetchCosts = async (canLoading = false) => {
  //   // eslint-disable-next-line no-unused-expressions
  //   canLoading && setLoading(true);
  //   try {
  //     const { data } = await api.get('/costCenters/costs/all');
  //     setCostsOptions(data);
  //   } catch (error) {
  //     errorHandler(error);
  //   }
  //   // eslint-disable-next-line no-unused-expressions
  //   canLoading && setLoading(false);
  // };

  const handleCostCenterChange = id => {
    const selected = costCenterOptions.find(costCenter => costCenter.id === id);

    if (selected?.costs) {
      setCostsOptions(selected.costs);
    } else {
      setCostsOptions([]);
    }
  };

  const handleChangePage = async page => {
    setLoadingPeople(true);
    try {
      const response = await api.get(`/people?page=${page}`, {
        params: {
          search,
        },
      });
      const { data } = response;
      setPeopleOptions(data.data);
      setMeta(data.meta);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoadingPeople(false);
    }
  };

  useEffect(() => {
    handleChangePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const tableColumns = [
    {
      title: t('screens:people.data.id'),
      dataIndex: 'id',
      key: 'id',
      // visible: false,
    },
    {
      title: t('screens:people.data.name'),
      key: 'name',
      render: (text, record) => <span>{record.name}</span>,
    },
    {
      title: t('screens:people.data.email'),
      key: 'email',
      render: (text, record) => <span>{record.email}</span>,
    },
    // {
    //   title: "Ativo",
    //   key: 'active',
    //   render: (text, record) => <span>{record.active ? 'Sim' : 'Não'}</span>,
    // }
  ];

  const fetchProviders = async () => {
    try {
      const { data } = await api.get('/providers');
      setProvidersOptions(data);
    } catch (error) {
      errorHandler(error);
    }
  };

  const fetchBankAccounts = async () => {
    try {
      const { data } = await api.get('/bankAccounts');
      setbankAccountOptions(data);
    } catch (error) {
      errorHandler(error);
    }
  };

  const fetchScreenData = async () => {
    setLoading(true);
    try {
      await Promise.all([fetchCostCenters(), fetchBankAccounts(), fetchProviders()]);
      if (!movementID) {
        setCostsOptions([]);
        setRecordData(initialValues);
        setSelectedRowKeys([]);
        setSelectedRowName('');
        setSearch('');
      } else {
        await fetchRecords();
      }
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleRemoveFile = () => {
    if (document.getElementById('uploadButton')) {
      document.getElementById('uploadButton').style.cursor = 'pointer';
    }
    setFile(null);
    setDeleteOldFile(true);
  };

  const beforeUpload = newFile => {
    setLoading(true);

    let justOne = true;
    if (file) {
      justOne = false;
      message.error('Você só pode anexar 1 arquivo');
    }

    const isValid =
      newFile.type === 'image/jpeg' ||
      newFile.type === 'image/jpg' ||
      newFile.type === 'image/png' ||
      newFile.type === 'application/pdf';
    if (!isValid) {
      message.error('Você só pode anexar arquivos do tipo: JPG/JPEG/PNG/PDF');
      setTimeout(() => {
        handleRemoveFile();
      }, 100);
    }
    const isLt2M = newFile.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      message.error('O arquivo deve ter menos de 20MB!');
      setTimeout(() => {
        handleRemoveFile();
      }, 100);
    }

    setLoading(false);
    return isValid && isLt2M && justOne;
  };

  const handleUpload = event => {
    setLoading(true);

    if (!event.file.originFileObj) {
      setLoading(false);
      return;
    }

    let extension = '';
    let name = '';
    if (event.file.name.substring(event.file.name.length - 4) === 'jpeg') {
      extension = event.file.name.substring(event.file.name.length - 5);
      name = event.file.name.replaceAll('.', '');
      name = name.substring(0, name.length - 4);
    } else {
      extension = event.file.name.substring(event.file.name.length - 4);
      name = event.file.name.replaceAll('.', '');
      name = name.substring(0, name.length - 3);
    }
    event.file.name = name + extension;

    if (!event.file.id) {
      getBase64(event.file.originFileObj, image => {
        event.file.base64Url = image;
      });
    }
    document.getElementById('uploadButton').style.cursor = 'no-drop';
    setTimeout(() => {
      setFile(event.file);
      setLoading(false);
    }, 500);
  };

  // for table people

  const start = () => {
    setLoadingPeople(true);
    // ajax request after empty completing
    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoadingPeople(false);
    }, 1000);
  };

  const onSelectChange = (newSelectedRowKeys, setValues, values) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
    // get name of selected row
    const selectedRow = peopleOptions.find(item => item.id === newSelectedRowKeys[0]);
    // console.log('selectedRow', selectedRow);
    setSelectedRowName(selectedRow.name);
    setSearch('');
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  useEffect(() => {
    if (visible) {
      fetchScreenData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const movementsSchema = Yup.object().shape({
    description: Yup.string().required(),
    cost_id: Yup.string().nullable(),
    cost_center_id: Yup.number().integer().required(),
    type: Yup.string()
      .required()
      .matches(/(input|output)/, 'Insira um tipo válido!', { excludeEmptyString: true }),
    paid_out: Yup.boolean().required(),
    value: Yup.number().min(1).required(),
  });

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={recordData}
      enableReinitialize
      onSubmit={handleSave}
      validationSchema={movementsSchema}
    >
      {({ errors, isSubmitting, submitForm, resetForm, setValues, values }) => (
        <Modal
          title={recordData.id ? `${t('screens:editing')}: ${recordData.description}` : t('screens:movements.title')}
          onCancel={onClose}
          style={{ maxWidth: '850px' }}
          afterClose={resetForm}
          visible={visible}
          loading={loading || isSubmitting}
          centered
          width="100%"
          footer={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <ModalFooter
              type={permissions && !permissions.includes('@movement/edit') && 'info'}
              onOk={submitForm}
              loading={loading || isSubmitting}
              onCancel={onClose}
            />
          }
        >
          <Spin spinning={loading || isSubmitting}>
            <Form>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Row>
                    {/* type */}
                    <FormControl
                      error={errors.type}
                      cols={{ xs: 24 }}
                      field="type"
                      label={t('screens:movements.data.type')}
                      required
                    >
                      <Radio.Group name="type" buttonStyle="solid">
                        <Radio.Button value="input">
                          <FaPlus /> {t('screens:movements.data.input')}
                        </Radio.Button>
                        <Radio.Button value="output">
                          <FaMinus /> {t('screens:movements.data.output')}
                        </Radio.Button>
                      </Radio.Group>
                    </FormControl>
                    {/* person */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.person_id}
                      field="person_id"
                      label={t('fields:person_id')}
                    >
                      <Space direction="horizontal">
                        {hasSelected ? (
                          <span style={{ marginLeft: 8, color: hasSelected ? 'green' : '#cccccc' }}>
                            {`${selectedRowName}`}
                          </span>
                        ) : (
                          <Search
                            placeholder="Buscar"
                            allowClear
                            onSearch={value => {
                              setSearch(value);
                            }}
                            style={{
                              width: 395,
                            }}
                          />
                        )}

                        {hasSelected && (
                          <Tooltip placement="right" color="red" title="Remover pessoa">
                            <ButtonAntd
                              type="text"
                              size="small"
                              shape="circle"
                              // danger
                              icon={<CloseOutlined />}
                              onClick={start}
                              disabled={!hasSelected}
                              loading={loadingPeople}
                            />
                          </Tooltip>
                        )}
                      </Space>
                    </FormControl>
                    {/* supplier */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.provider_id}
                      field="provider_id"
                      label={t('fields:provider_id')}
                    >
                      <Select name="provider_id" showSearch allowClear optionFilterProp="children">
                        <Select.Option value={null}>Nenhum</Select.Option>
                        {providersOptions &&
                          providersOptions.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.business ? item.company_name : item.contact && item.contact.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </FormControl>
                    {!hasSelected && (
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table
                          pagination={false}
                          rowKey="id"
                          rowSelection={{
                            type: 'radio',
                            getCheckboxProps: record => ({
                              disabled: !record.active,
                            }),
                            ...rowSelection,
                          }}
                          size="small"
                          loading={loading}
                          dataSource={peopleOptions}
                          columns={tableColumns}
                          rowClassName={record => (!record.active ? 'inactive-row' : '')}
                        />
                        <Pagination
                          style={{ marginTop: 10, marginBottom: 30 }}
                          onChange={value => {
                            handleChangePage(value);
                          }}
                          size="small"
                          meta={meta}
                        />
                      </Col>
                    )}

                    {/* cost center */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.cost_center_id}
                      field="cost_center_id"
                      label={t('fields:cost_center_id')}
                    >
                      <Select
                        name="cost_center_id"
                        onSelect={id => {
                          handleCostCenterChange(id);
                          setValues({ ...values, cost_center_id: id, cost_id: '' });
                        }}
                        onClear={() => {
                          setValues({ ...values, cost_id: '' });
                          setCostsOptions([]);
                        }}
                        allowClear
                        optionFilterProp="children"
                      >
                        {costCenterOptions &&
                          costCenterOptions.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </FormControl>
                    {/* cost */}
                    <FormControl cols={{ xs: 12 }} error={errors.cost_id} field="cost_id" label={t('fields:cost_id')}>
                      <Select name="cost_id" allowClear optionFilterProp="children">
                        {costsOptions &&
                          costsOptions.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </FormControl>
                    {/* description */}
                    <FormControl
                      cols={{ xs: 24 }}
                      error={errors.description}
                      field="description"
                      label={t('screens:movements.data.description')}
                      required
                    >
                      <Input name="description" disabled={permissions && !permissions.includes('@movement/edit')} />
                    </FormControl>
                    {/* bank account */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.bank_account_id}
                      field="bank_account_id"
                      label={t('fields:bank_account_id')}
                    >
                      <Select name="bank_account_id" allowClear optionFilterProp="children">
                        {bankAccountOptions &&
                          bankAccountOptions.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.description} - {item.bank}
                            </Select.Option>
                          ))}
                      </Select>
                    </FormControl>
                    {/* bank statement */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.bank_statement}
                      field="bank_statement"
                      label={t('screens:movements.data.bank_statement')}
                    >
                      <Input name="bank_statement" disabled={permissions && !permissions.includes('@movement/edit')} />
                    </FormControl>
                    {/* due date */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.due_date}
                      field="due_date"
                      label={t('screens:movements.data.due_date')}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        name="due_date"
                        placeholder={t('messages:select')}
                        locale={locale}
                      />
                    </FormControl>
                    {/* pay day */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.pay_day}
                      field="pay_day"
                      label={t('screens:movements.data.pay_day')}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        name="pay_day"
                        placeholder={t('messages:select')}
                        locale={locale}
                      />
                    </FormControl>
                    {/* value */}
                    <FormControl
                      cols={{ xs: 12 }}
                      error={errors.value}
                      field="value"
                      label={t('screens:movements.data.value')}
                      required
                    >
                      <InputCurrency
                        name="value"
                        currency="R$"
                        number={false}
                        maxLength="9"
                        disabled={permissions && !permissions.includes('@movement/edit')}
                        onChange={event => {
                          setTimeout(() => {
                            setValues({ ...values, value: dynamicCost(event.target.value) });
                          }, 100);
                        }}
                      />
                    </FormControl>
                    {/* paid out */}
                    <FormControl
                      error={errors.paid_out}
                      cols={{ xs: 12 }}
                      field="paid_out"
                      label={t('screens:movements.data.paid_out')}
                      required
                    >
                      <Radio.Group name="paid_out" buttonStyle="solid">
                        <Radio.Button value>{t('messages:yes')}</Radio.Button>
                        <Radio.Button value={false}>{t('messages:no')}</Radio.Button>
                      </Radio.Group>
                    </FormControl>
                  </Row>
                  <Row>
                    <Can permission="@people/edit">
                      <Upload
                        disabled={file}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={handleUpload}
                      >
                        <Button style={{ marginLeft: '1rem' }} id="uploadButton" color="default">
                          Anexar arquivo
                          <FaUpload />
                        </Button>
                      </Upload>
                    </Can>
                  </Row>
                  <Row>
                    <Thumb
                      file={file}
                      fileURL={recordData.attachment_url}
                      onDelete={() => {
                        handleRemoveFile();
                      }}
                    />
                  </Row>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
